<template>
  <a-modal
    :footer="null"
    :width="640"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :maskClosable="false"
    :title="$t('multi_status.modal_title')"
    class="j-modal-box-shadow"
    :maskStyle="{ 'background-color': 'inherit' }"
  >
    <div class="container">
      <div class="icon-container">
        <WarnIcon />
      </div>
      <a-form
        ref="form"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        class="form-container"
      >
        <div class="j-content title">
          {{
            type === 1
              ? $t('multi_status.title_1')
              : isSpare
              ? $t('multi_status.title_2_spare')
              : $t('multi_status.title_2')
          }}
        </div>
        <div class="sub-title">
          {{
            type === 1
              ? $t('multi_status.sub_title_1')
              : isSpare
              ? $t('multi_status.sub_title_2_spare')
              : $t('multi_status.sub_title_2')
          }}
        </div>

        <a-form-item name="confirmStatus">
          <a-radio-group v-model:value="form.confirmStatus">
            <a-radio :style="radioStyle" :value="0">
              {{ $t('multi_status.option_1') }}
            </a-radio>
            <a-radio :style="radioStyle" :value="1">
              {{ $t('multi_status.option_2') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="form.confirmStatus === 1"
          name="vin"
          :rules="[
            {
              type: 'string',
              required: true,
              message: $t('multi_status.vin_msg')
            },
            validateLength(30)
          ]"
        >
          <a-input
            :placeholder="$t('multi_status.vin_placeholder')"
            v-model:value="form.vin"
          />
        </a-form-item>

        <div style="text-align: right;">
          <a-button
            :loading="loading"
            @click="handleCancel"
            class="j-outline-btn1 j-height-auto"
          >
            {{ $t('multi_status.cancel') }}
          </a-button>
          <a-button
            :loading="loading"
            @click="handleConfirm"
            type="primary"
            class="j-height-auto"
            style="margin-left: 10px;"
          >
            {{ $t('multi_status.confirm') }}
          </a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { message } from 'ant-design-vue';
import WarnIcon from '@/components/icons/WarnIcon.vue';
import { getUniqueVin } from '@/api/apis';
import { validateLength } from '@/utils/validate';

export default defineComponent({
  name: 'MultiStatusModal',
  emits: ['after-close'],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    type: {
      type: Number,
      required: true,
      default: 0 // 1 - 图组进图册 2 - 加入购物车
    },
    isSpare: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WarnIcon
  },
  data() {
    return {
      validateLength,
      visible: true,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        vin: '',
        confirmStatus: 0
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      returnData: {},
      isCancel: true
    };
  },

  methods: {
    handleAfterClose() {
      this.$emit('after-close', this.returnData, this.isCancel);
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          if (this.form.confirmStatus === 1) {
            const res = await getUniqueVin({
              type: this.type === 1 ? 2 : 3, // 2 - 图组 3 - 子配件,
              vin: this.form.vin,
              name: this.$t(this.item.partName)
            });

            if (res.success) {
              if (!res.result) {
                return;
              }
              const result = res.result || {};
              this.returnData =
                this.type === 1
                  ? {
                      diagramId: result.id
                    }
                  : result;
              this.isCancel = false;
              this.handleCancel();
            } else {
              message.error(this.$t(res.message));
              return;
            }
          } else {
            this.returnData =
              this.type === 1
                ? {
                    diagramId: this.item.id
                  }
                : this.item;
            this.isCancel = false;
            this.handleCancel();
          }
        })
        .catch();
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  .form-container {
    flex: 1;

    .title {
      margin-bottom: 10px;
      font-weight: bold;
    }

    .sub-title {
      margin-bottom: 30px;
    }
  }
  .icon-container {
    font-size: 50px;
    margin-right: 20px;
    display: flex;
  }
}
</style>
